import { render } from "./New-request.vue?vue&type=template&id=2b134c62&scoped=true"
import script from "./New-request.vue?vue&type=script&lang=js"
export * from "./New-request.vue?vue&type=script&lang=js"

import "./New-request.vue?vue&type=style&index=0&id=2b134c62&scoped=true&lang=css"

import exportComponent from "/home/django/v1/mintit-engineer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b134c62"]])

export default __exports__